module.exports = __webpack_public_path__ + "img/diamante-iii.ca15c83a.png";